<table  #table style="width: 100%;border-collapse: collapse;border-spacing: 0px;" class="realTable" [hidden]="!visible">
    <thead>
        <ng-container *ngFor="let w of getHeader()" axf-widget-renderer [widget]="w" [parent]="this" [mode]="'print'">
        </ng-container>
    </thead>
    <tbody>
        <ng-container *ngFor="let w of getBody()" axf-widget-renderer [widget]="w" [parent]="this" [mode]="'print'">
        </ng-container>
    </tbody>
</table>